window.Contacts = {
	prepareFilterForm: function(){
		var options = {success:function(data){Contacts.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("contactsFilterForm", "contacts", options);
	},
	
	processFilterForm: function(data){
		Contacts.buildPagenum(data.contacts_metadatas.pagenum, data.contacts_metadatas.nbPages);
		Listing.refresh("contactsListing", data, data.contacts_metadatas);
	},
	
	buildPagenum: function(pagenum, nbpage){
		
	},
	
	sendStaffPwd: function(staffid){
		var msg =  Loc.g('Vous allez renvoyer un nouveau mot de passe à ce collaborateur.') + '<br /><br />' + Loc.g('Son ancien mot de passe sera désactivé.');
		var options = {
			type: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Renvoi de mot de passe"),
			buttons		: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Valider"), click : function(){Contacts.processSendStaffPwd(staffid, $(this));}}
            ]
		};

		MyWindow.alert(msg, options);
	},
	
	processSendStaffPwd: function(staffid, me){
		var options = {action:"sendStaffPassword", staffid:staffid};
		MyFacture.post("contacts", options, function(data){
			MyWindow.alert(Loc.g('Le nouveau mot de passe a été envoyé au collaborateur.'), {type: 'confirm', title: 'Mot de passe envoyé'});
		}, "json");
	},
	
	
};